// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"689":"42fd3914","983":"4f555035"}[chunkId] + ".chunk.js";
};